// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3rMsm","label":"Labeled_label__Sy0sI","divider":"Labeled_divider__2lAbg"};